import { ErrorNotification } from '@sleepstation/components'
import { maxWidth, padding } from '@sleepstation/style-api-helpers'
import React, { useContext } from 'react'
import styled from 'styled-components'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TITLE = `We’ve experienced a problem loading your report`
const BODY = `We’ve notified our developers about this problem and they’ll work to resolve it ASAP. If you need access to your report today, just send us a message and our team will be able to help`
const LINK_LABEL = `Send us a message`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  /* stylelint-disable  */
  ${padding([
    [3, 1],
    [3, 1],
    [5, 0],
  ])}
  /* stylelint-enable  */

  > * {
    ${maxWidth([100, 22, 29])}
    margin: 0 auto;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SleepReportErrorNotification = ({ ...props }) => {
  const { appRouting } = useContext(RoutingContext)
  const linkUrl = appRouting.chatMessagesPath

  return (
    <Layout>
      <ErrorNotification
        title={TITLE}
        body={BODY}
        linkLabel={LINK_LABEL}
        linkUrl={linkUrl}
        {...props}
      />
    </Layout>
  )
}

export default SleepReportErrorNotification
